// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_iQf1E","main":"index_main_1Tjqn","search":"index_search_V-qEG","logo":"index_logo_M5jEo"};